var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "form-config": _vm.formConfig,
          url: _vm.url,
          otherParams: { taskType: 1 },
          columns: _vm.columns,
          "toolbar-config": _vm.toolbarConfig,
          "export-config": _vm.exportConfig,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }